import { AppState } from '../../store';

type status = 'not_submit' | 'submit_loading' | 'submit' | 'error';

export const getStatus = ({ validation }: AppState): status => {
  return validation.status;
};
